import React from "react";
import { FormattedMessage } from "react-intl";
import Link from "theme/components/atoms/Typography/Link";
import Stars from "theme/components/molecules/Stars";
import { addReviewAnchorId } from "theme/modules/Reviews/PublishProductReview";
import { anchorId } from "../ProductReviews/ProductReviews";

export const hasProductReviewsSynthesis = (product) =>
  product.reviewsLayerSynthesis && product?.canBeReviewed;

const ProductReviewsSynthesis = ({ product }) => {
  if (!hasProductReviewsSynthesis(product)) {
    return null;
  }

  if (product.reviewsLayerSynthesis.total === 0) {
    return (
      <div className="product-reviews-synthesis">
        <div className="product-reviews-synthesis__actions">
          <div className="product-reviews-synthesis__link">
            <Link to={`#${addReviewAnchorId}`}>
              <FormattedMessage
                id="modules.Reviews.ProductReviewsSynthesis.firstReview"
                defaultMessage="Be the first to review this product"
              />
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      itemProp="aggregateRating"
      itemScope
      itemType="https://schema.org/AggregateRating"
      className="product-reviews-synthesis"
    >
      <meta
        itemProp="ratingValue"
        content={product.reviewsLayerSynthesis.ratingAverage.toFixed(1)}
      />
      <meta itemProp="bestRating" content="5" />
      <div className="product-reviews-synthesis__stars">
        <Stars rating={product.reviewsLayerSynthesis.ratingAverage} />
      </div>
      <div className="product-reviews-synthesis__actions">
        <div className="product-reviews-synthesis__link">
          <Link to={`#${anchorId}`}>
            <FormattedMessage
              id="modules.Reviews.ProductReviewsSynthesis.total"
              defaultMessage="{total, plural, =1 {1 Review} other {{totalText} Reviews}}"
              values={{
                total: product?.reviewsLayerSynthesis.total,
                totalText: (
                  <span itemProp="reviewCount">
                    {product?.reviewsLayerSynthesis.total}
                  </span>
                ),
              }}
            />
          </Link>
        </div>
        <div className="product-reviews-synthesis__link">
          <Link to={`#${addReviewAnchorId}`}>
            <FormattedMessage
              id="modules.Reviews.ProductReviewsSynthesis.addReview"
              defaultMessage="Add your review"
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProductReviewsSynthesis;
